$(document).ready(function ($) {
    let lastUpdate = 0;

    $.get("/changes.php", null, function (result) {
        lastUpdate = result;
    });

    let interval = setInterval(function () {
      $.get("/changes.php", null, function (result) {
          if(result > lastUpdate) {
              clearInterval(interval);

              setTimeout(function() {
                  location.reload(true);
              }, 1000);
          }
      });
    }, 1000);
});
